import SubmenuWithTabs from './SubmenuWithTabs';
import { SubmenuWithTabsProps, SubmenuWithTabsValueProps } from './types';

export type { SubmenuWithTabsProps, SubmenuWithTabsValueProps };
export default SubmenuWithTabs;
